import type { SchoolTestApi } from '@mathflat/domain/@entities/(Content)/SchoolTest/api'
import type { SchoolTestDomain } from '@mathflat/domain/@entities/(Content)/SchoolTest/domain'
import type { RegionDomain } from '@mathflat/domain/@entities/Region/domain'
import type {
  AllGradeSubject,
  Revision,
  SchoolType,
  Semester,
} from '@mathflat/domain/@entities/SchoolSystem/schema'
import type { DefaultResponse } from '@mathflat/shared/@types/mathflatApi'

import type { PaginationResponse } from '@/types/common/api'
import maxios from '@/utils/axios/maxios'

export const schoolTestApi = (() => {
  return {
    // 학교별 기출 시험지 검색
    getSchoolTestList: async (params?: SchoolTestsRequestParams, signal?: AbortSignal) => {
      return maxios.get<PaginationResponse<res.SchoolTest[]>>('/school-tests/v2/page', {
        params,
        signal,
      })
    },

    // 학교별 기출 시험지 다운로드
    getSchoolTestDownloadFile: async (params: {
      schoolTestIds: number[]
      presignedUrlType: common.FileAccessType
    }) => {
      return maxios.get<common.PresignedFile>('/school-tests/v2/download', {
        params,
      })
    },

    // deprecated
    getSchoolsBySchoolInfo: async (params: SchoolsBySchoolInfoRequest, signal?: AbortSignal) => {
      return maxios
        .get<DefaultResponse<RegionDomain.SchoolsUnderRegion[]>>('/school-tests/schools', {
          params,
          signal,
        })
        .then((res) => res.data.data)
    },
    getSchoolTestsGroupBySchool: async (params: SchoolsBySchoolInfoRequest) => {
      return maxios
        .get<SchoolTestApi.Response.SchoolTestGroupBySchool>('/school-tests/group-by-school', {
          params,
        })
        .then((res) => res.data)
    },

    getMonthlyPdfQuotaStatus: () => {
      return maxios.get<SchoolTestApi.Response.PdfQuotaStatus>('/school-tests/pdf-download-status')
    },

    postPdfDownloadLog: (payload: SchoolTestApi.Request.PostPdfDownloadLog) => {
      maxios.post<never, never, SchoolTestApi.Request.PostPdfDownloadLog>(
        '/school-tests/pdf-download-log',
        payload,
      )
    },

    getRecentlyDownloadedSchools: (params: { size: number }) => {
      return maxios.get<{ schools: RecentlyDownloadedSchool[] }>(
        '/school-tests/recently-downloaded-schools',
        { params },
      )
    },
  }
})()

export type SimilarWorksheet = {
  id: number
  title: string
  year: number
  grade: AllGradeSubject
  semester: Semester
  schoolTestType: SchoolTestDomain.SchoolTestType
}

export type SchoolTestsRequestParams = {
  schoolCodes?: string[]
  schoolName?: string
  schoolType?: SchoolType
  grade?: AllGradeSubject
  semester?: Semester
  years?: number[]
  schoolTestType?: SchoolTestDomain.SchoolTestType
  page?: number
  size?: number
  provideTypes?: SchoolTestDomain.ProvideType[]
  revision?: Revision
}

export type RecentlyDownloadedSchool = {
  schoolCode: string
  schoolName: string
}

export type SchoolsBySchoolInfoRequest = Partial<{
  schoolType: SchoolType
  grade: AllGradeSubject
  semester: Semester
  revision: Revision
  schoolName: string
  provideTypes: SchoolTestDomain.ProvideType[]
  uploaderTypes: SchoolTestDomain.UploaderType[]
}>
